export enum EmojiType {
    Smile = "smile",
    Sad = "sad",
    Laugh = "laugh",    
    Angry = "angry"
  }
  